import React, { useEffect, useState, useRef } from 'react'
import { Row, Col, Container } from '../../../../../SPRINTA/v2/atoms/Grid'
import Box from '../../../../../SPRINTA/atoms/Box'
import PlaceHolder from '../../../../../SPRINTA/v2/atoms/Placeholder'
import T from '../../../../../SPRINTA/translate/T'
import Font from '../../../../../SPRINTA/atoms/Font';
import * as user from '../../../../utils/user'
import Button from '../../../../../SPRINTA/v2/atoms/Button';
import Dialog from '../../../../../SPRINTA/v2/molecules/Dialog';
import Display from '../../../../../SPRINTA/v2/atoms/Display';
import * as Url from '../../../../../SPRINTA/v2/helpers/Url';
import Modal from '../../../../../SPRINTA/v2/atoms/Modal';


function ConfigApps(props) {

    const d = useRef(null)

    const [loading, setLoading] = useState(true)
    const [loadingBtn, setLoadingBtn] = useState(false)
    const [isLinked, setIslinked] = useState(false)
    const [stravaModal, setStravaModal] = useState(false)

    useEffect(() => {
        user.appsMine()
        .then(resp => {
            if(resp.errors) {
                d.current.alert(resp.errors[0].message)
                setIslinked(false)
                setLoading(false)
            } else {
                let strava = resp.filter(item => item.app_name === "STRAVA")
                if(strava.length === 0) {
                    setIslinked(false)
                    setLoading(false)
                } else {
                    setIslinked(true)    
                    setLoading(false)
                    
                }
            }
        })
    }, [] )
    
    useEffect(() => {
        setLoadingBtn(false)
        let verifyUrl = Url.GetURLParameters()
        if(verifyUrl.code) {
            user.authorizeStrava(verifyUrl.code)
            .then(resp => {
                if(resp.errors) {
                    setIslinked(false)
                    setLoading(false)
                    d.current.alert(resp.errors[0].message)
                } else {
                    setIslinked(true)
                    setLoading(false)
                }
                
            })
            Url.SetURLParameters([])
        } 
    }, [props.match.params.token, props.isLogged])

    if (loading) {
        return (
            <div style={{ float: 'left', width: '100%' }}>
                <Loading />
            </div>
        )
    }

    const removeStrava = () => {
        setLoadingBtn(true)
        user.unauthorizeStrava()
        .then( resp => {
            if(resp.errors) {
                setIslinked(true)
                setLoadingBtn(false)
                setStravaModal(false)
                d.current.alert(resp.errors[0].message)
            } else {
                setIslinked(false)
                setLoadingBtn(false)
                setStravaModal(false)
            }
        })
    }

    return ( 
        <Row style={{float: 'left'}}>
            <Col size='12' spacing={2}>
                <Font heading='3' weight="100" style={{marginBottom: '30px'}}>
                    {T.text('apps_title')}
                </Font>
                <Font>
                    {T.text('apps_content')}
                </Font>
            </Col>
            <Col size='12 6 4' spacing={1}>    
                <Box style={{background: '#f9f9f9', padding:'30px', borderRadius: '4px', textAlign: 'center'}}>
                    <img src={require('./strava.png')} alt='Logo Strava' style={{maxWidth: '95px', display: 'block', margin: '0 auto 30px auto'}} />
                    <Button lightOutline={isLinked} primary={!isLinked} loading={loadingBtn} onClick={() => setStravaModal(1)} inline>{isLinked ? 'Desconectar' : 'Conectar'}</Button>
                </Box>
            </Col>

            <Dialog ref={d} />

            <Modal active={stravaModal} handleClose={() => setStravaModal(0)}>
                {!isLinked ? (
                    <div style={{textAlign: 'center'}}>
                        <Display size={3} style={{marginBottom: '20px', display: 'block'}}>
                            Você deseja vincular sua conta do Strava ao seu perfil no SPRINTA?
                        </Display>
                        <a href={`https://www.strava.com/oauth/authorize?client_id=2044&response_type=code&redirect_uri=${window.location.href}&scope=read,activity:read`}>
                            <Button primary inline loading={loadingBtn} onClick={() => setLoadingBtn(true)}>Entrar com Strava</Button>
                        </a>
                    </div>
                ) : (
                    <div style={{textAlign: 'center'}}>
                        <Display size={3} style={{marginBottom: '20px', display: 'block'}}>
                            Você deseja remover o vínculo entre sua conta do Strava e o seu perfil no SPRINTA?
                        </Display>
                        <Button primary inline loading={loadingBtn} onClick={() => removeStrava()}>Remover Strava</Button>
                    </div>
                )}
            </Modal>
        </Row>

    )
    
}

export default ConfigApps

function Loading() {
    return (
        <div>
            <Container>
				<Row>
					<Col size='8 4' spacing={1}>
                        <PlaceHolder box style={{ height: '40px'}} />
                    </Col>
				</Row>
				<Row>
					<Col size='12' spacing='mid'>
                        <PlaceHolder box style={{ height: '25px'}} />
                    </Col>
					<Col size='12' spacing={1}>
                        <PlaceHolder box style={{ height: '25px'}} />
                    </Col>
				</Row>
                <Row>
                    <Col size='12 6 4' spacing={1}>
                        <PlaceHolder box style={{ height: '150px'}} />
                    </Col>
                    <Col size='12 6 4' spacing={1}>
                        <PlaceHolder box style={{ height: '150px'}} />
                    </Col>
                    <Col size='12 6 4' spacing={1}>
                        <PlaceHolder box style={{ height: '150px'}} />
                    </Col>
                </Row>
            </Container>
        </div>
    )
}



// WEBPACK FOOTER //
// ./src/App/pages/Profile/Pages/ConfigApps/index.js